module.exports = __webpack_public_path__ + "static/2-85f0456567a4517d3b507bd6574076c3.jpg";